import Vue from 'vue'

import * as signalR from "@aspnet/signalr";
Vue.use(signalR)

export default signalR
